import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

import InlineConfirmation from "components/InlineConfirmation"

const ApproveSelfie = ({ id }) => {
  const [, runMutation] = useMutation(workflowMutation)

  const handleSubmit = () => {
    return runMutation({ id }).then(result => {
      if (result.error) {
        NotificationManager.error(result.error.message)
      }

      const { failures } = result.data.approveSelfie
      if (failures) {
        NotificationManager.error(failures.map(f => f.message).join(", "))
      } else {
        NotificationManager.success(
          "Success! You have been assigned as the reviewer!"
        )
      }
    })
  }

  return (
    <InlineConfirmation
      handleSubmit={handleSubmit}
      buttonText="Approve Selfie"
      type="success"
    />
  )
}

const workflowMutation = gql`
  mutation ($id: ID!) {
    approveSelfie(id: $id) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default ApproveSelfie
